import { useTranslation } from '@pancakeswap/localization'
import { Flex, Link, SubMenu, SubMenuItem, Text, useModal } from '@pancakeswap/uikit'
import truncateHash from '@pancakeswap/utils/truncateHash'
import { useStatModalProps } from 'state/predictions/hooks'
import { useProfileForAddress } from 'state/profile/hooks'
import { PredictionUser } from 'state/types'
import styled from 'styled-components'
import { getBlockExploreLink } from 'utils'
import { useConfig } from 'views/Predictions/context/ConfigProvider'
import WalletStatsModal from '../WalletStatsModal'
import { NetWinningsRow, Row } from './styles'

const StyledCard = styled.div`
  padding: 24px;
  height: unset;
  position: relative;
  border-radius: 16px;
  .txt-dollar {
    font-size: 14px;
  }
  > div {
    background: transparent;
    border: none;
    border-radius: 0;
  }
  .cup-img {
    position: absolute;
    top: -24px;
    right: 0;
    @media screen and (max-width: 700px) {
      width: 80px;
      height: 80px;
    }
  }
  @media screen and (max-width: 700px) {
    padding: 16px;
  }
`
const CardHead = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
  .rank-user {
    .rank-address {
      font-size: 16px;

      font-weight: 700;
      line-height: 140%;
      margin-bottom: 4px;
      color: #fff;
      &:hover {
        color: #03f5ae;
      }
    }
    .rank-number {
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
      color: rgba(255, 255, 255, 0.6);
    }
  }
`
interface RankingCardProps {
  rank: 1 | 2 | 3
  user: PredictionUser
  bg: any
  icon: any
}

const getRankingColor = (rank: number) => {
  if (rank === 3) {
    return 'bronze'
  }

  if (rank === 2) {
    return 'silver'
  }

  return 'gold'
}

const RankingCard: React.FC<React.PropsWithChildren<RankingCardProps>> = ({ rank, user, bg, icon }) => {
  const { t } = useTranslation()
  const rankColor = getRankingColor(rank)
  const { profile } = useProfileForAddress(user.id)
  const { result, address, leaderboardLoadingState } = useStatModalProps(user.id)
  const { token, api } = useConfig()

  const [onPresentWalletStatsModal] = useModal(
    <WalletStatsModal
      api={api}
      token={token}
      result={result}
      address={address}
      leaderboardLoadingState={leaderboardLoadingState}
    />,
    true,
    false,
    'RankingCardWalletStatsModal',
  )

  return (
    // <StyledCard ribbon={<CardRibbon variantColor={rankColor} text={`#${rank}`} ribbonPosition="left" />}>
    <StyledCard style={{ background: bg }}>
      <StyleFlex flexDirection="column">
        <CardHead>
          <img src="/images/leaderboard/avt.svg" alt="avt" />
          {/* <ProfileAvatar src={profile?.nft?.image?.thumbnail} height={50} width={50} /> */}
          <div className="rank-user">
            <SubMenu
              component={<div className="rank-address">{profile?.username || truncateHash(user.id)}</div>}
              options={{ placement: 'bottom-start' }}
            >
              <SubMenuItem onClick={onPresentWalletStatsModal}>{t('View Stats')}</SubMenuItem>
              <SubMenuItem as={Link} href={getBlockExploreLink(user.id, 'address')} bold={false} color="text" external>
                {t('View in Explorer')}
              </SubMenuItem>
            </SubMenu>
            <div className="rank-number">Top #{rank}</div>
          </div>
        </CardHead>
      </StyleFlex>
      <Row mb="8px">
        <Text fontSize="14px" color="white60">
          {t('Win Rate')}
        </Text>
        <Text fontWeight="bold" color="white" fontSize="14px">
          {/* {`${user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}%`} */}
          {`${parseFloat(
            user.winRate.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 }),
          ).toFixed(2)}%`}
        </Text>
      </Row>
      {/* <NetWinningsRow amount={user.netBNB} /> */}
      <NetWinningsRow amount={user.netETH} />
      <Row>
        <Text fontSize="14px" color="white60">
          {t('Rounds Won')}
        </Text>
        <Text
          fontSize="14px"
          fontWeight="bold"
        >{`${user.totalBetsClaimed.toLocaleString()}/${user.totalBets.toLocaleString()}`}</Text>
      </Row>
      <img src={icon} alt="cup" className="cup-img" />
    </StyledCard>
  )
}

const StyleFlex = styled(Flex)`
  margin-bottom: 24px;
  @media screen and (max-width: 700px) {
    margin-bottom: 16px;
  }
`
export default RankingCard
